// Mirrors the 40px commit distance used by useSheetDrag so peek/expand feel
// matches the selected-location drawer. No dismiss direction — the search
// drawer is always mounted while in search mode (dismiss semantics live at
// AirspacePage level in Phase 9).
export const EXPAND_DY_PX = -40;

export const COLLAPSE_DY_PX = 40;
